import {memo} from 'react'
import type {ReceivedChatMessage} from '@livekit/components-react'
import {cn} from '@/shared/lib/cn'

interface ChatMessageProps {
  message: ReceivedChatMessage
  isOwn: boolean
}

function formatTime(timestamp: number): string {
  return new Date(timestamp).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
}

function getInitials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase() ?? '')
    .join('')
}

export const ChatMessage = memo(function ChatMessage({message, isOwn}: ChatMessageProps) {
  const senderName = message.from?.name ?? message.from?.identity ?? 'Unknown'
  const initials = getInitials(senderName)

  return (
    <div className={cn('flex gap-2 px-4 py-1.5', isOwn && 'flex-row-reverse')}>
      <div className="size-8 shrink-0 rounded-full bg-muted flex items-center justify-center text-xs font-semibold text-foreground/80 uppercase select-none">
        {initials || '?'}
      </div>
      <div
        className={cn(
          'flex flex-col gap-0.5 min-w-0 max-w-[75%]',
          isOwn && 'items-end w-full', // w-full чтобы пузырёк имел ширину и текст переносился
        )}
      >
        <div className={cn('flex items-baseline gap-2 w-full min-w-0', isOwn && 'justify-end')}>
          <span className="text-xs font-medium text-foreground/60 truncate min-w-0">
            {senderName}
          </span>
          <span className="text-[10px] text-muted-foreground shrink-0">
            {formatTime(message.timestamp)}
          </span>
        </div>
        <div
          className={cn(
            'px-3 py-1.5 rounded-2xl text-sm text-foreground leading-relaxed wrap-break-word min-w-0 w-full max-w-full overflow-hidden',
            isOwn ? 'bg-primary rounded-tr-sm' : 'bg-muted rounded-tl-sm',
          )}
        >
          {message.message}
        </div>
      </div>
    </div>
  )
})
